import type { StudentActiveCohort } from "../auth/api-client";

/** Teacher contact for sidebar help: current cohort route, else first enrolled cohort. */
export function studentHelpEmail(
  cohorts: readonly StudentActiveCohort[],
  pathname: string
): string | null {
  const cohortRoute = pathname.match(/^\/cohorts\/([^/]+)/)?.[1];
  if (cohortRoute) {
    const match = cohorts.find((c) => c.cohortId === cohortRoute);
    if (match?.teacherEmail) return match.teacherEmail;
  }
  return cohorts.find((c) => c.teacherEmail)?.teacherEmail ?? null;
}
